import React from "react";

import SiderLayout from "../../layouts/SiderLayout";
import { PrestationSlider } from "../../pages/Prestations/PrestationSider/Prestation.slider";
import routes from "../routes";
import { generateChildren } from "./RouterGenerator";
import { Outlet } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";

let childrenNormal = generateChildren([
  routes.prestations().detail,
  routes.prestations().detailInformations,
  routes.prestations().detailBilling,
]);

let childrenFullWidth = generateChildren([
  routes.prestations().detailInterpretes,
]);

let childrenNoMargin = generateChildren([routes.prestations().detailResume]);

let childSpecialEmpty = generateChildren([
  routes.prestations().confirmAnswerYes,
]);

export const prestationsRouteur = [
  {
    path: routes.prestations().path,
    handle: {
      crumb: e => routes.prestations().ressourceCrumb(e),
    },
    children: [
      {
        path: routes.prestations().confirmAnswerYes.path,
        element: (
          <MainLayout>
            <Outlet />
          </MainLayout>
        ),
        handle: {
          crumb: e => null,
        },
        children: childSpecialEmpty,
      },
      {
        path: routes.prestations().detail.path,
        element: (
          <SiderLayout>
            <PrestationSlider />
          </SiderLayout>
        ),
        handle: {
          crumb: e => routes.prestations().crumb(e),
        },
        children: childrenNormal,
      },
      {
        path: routes.prestations().detail.path,
        element: (
          <SiderLayout maxWidth="100%">
            <PrestationSlider />
          </SiderLayout>
        ),
        handle: {
          crumb: e => routes.prestations().crumb(e),
        },
        children: childrenFullWidth,
      },
      {
        path: routes.prestations().detail.path,
        element: (
          <SiderLayout mobileNoMargin>
            <PrestationSlider />
          </SiderLayout>
        ),
        handle: {
          crumb: e => routes.prestations().crumb(e),
        },
        children: childrenNoMargin,
      },
    ],
  },
];
